/**
 * Calendar config hook — reads /v1/config/calendar so UI bounds stay in
 * lock-step with backend validation.
 */

import { useQuery } from '@tanstack/react-query';

import { api } from '@core/api/client';

export interface CalendarRules {
  class_name_max_len: number;
  class_capacity_min: number;
  class_capacity_max: number;
  min_class_duration_minutes: number;
  max_class_duration_minutes: number;
  session_generation_weeks_ahead: number;
  branch_name_max_len: number;
  room_name_max_len: number;
  room_capacity_min: number;
  room_capacity_max: number;
  flags: { allow_conflict_override: boolean; [k: string]: boolean };
}

export const CALENDAR_RULES_FALLBACK: CalendarRules = {
  class_name_max_len: 200,
  class_capacity_min: 1,
  class_capacity_max: 200,
  min_class_duration_minutes: 15,
  max_class_duration_minutes: 240,
  session_generation_weeks_ahead: 4,
  branch_name_max_len: 200,
  room_name_max_len: 200,
  room_capacity_min: 1,
  room_capacity_max: 500,
  flags: { allow_conflict_override: true },
};

export function useCalendarConfig() {
  const q = useQuery({
    queryKey: ['config', 'calendar'] as const,
    queryFn: () => api.get<CalendarRules>('/v1/config/calendar'),
    staleTime: 5 * 60 * 1000,
  });
  return { rules: q.data ?? CALENDAR_RULES_FALLBACK, isLoading: q.isLoading };
}

